export const DEFAULT_CURRENCY = 'MYR';

const CURRENCY_SYMBOLS = {
  MYR: 'RM',
  THB: 'THB',
  SGD: 'SGD',
  USD: 'USD',
  IDR: 'IDR'
};

export const toHostCurrency = (currencyCode) => {
  const code = String(currencyCode || DEFAULT_CURRENCY).trim().toUpperCase();
  return code || DEFAULT_CURRENCY;
};

export const toStripeCurrency = (currencyCode) => toHostCurrency(currencyCode).toLowerCase();

export const getCurrencySymbol = (currencyCode) => {
  const code = toHostCurrency(currencyCode);
  return CURRENCY_SYMBOLS[code] || code;
};

const STRIPE_MIN_MAJOR = {
  MYR: 2,
  THB: 10,
  SGD: 0.5,
  USD: 0.5
};

export const isBelowStripeMinimum = (amount, currencyCode) => {
  const code = toHostCurrency(currencyCode);
  const min = STRIPE_MIN_MAJOR[code] != null ? STRIPE_MIN_MAJOR[code] : 0.5;
  return Number(amount) < min;
};

export const isStripePaymentMethodAllowed = (paymentMethod, currencyCode) => {
  const method = String(paymentMethod || '').toLowerCase();
  const code = toStripeCurrency(currencyCode);
  if (method === 'fpx') {
    return code === 'myr';
  }
  if (method === 'grabpay') {
    return code === 'myr' || code === 'sgd';
  }
  return true;
};
